import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/images/top-right-green-arrow.png'


const _hoisted_1 = { class: "flex-1 text-white h-full font-space-grotesk-regular" }
const _hoisted_2 = { class: "font-space-grotesk-regular text-xl text-permaWhite2 text-center mt-2" }
const _hoisted_3 = { class: "text-16px flex flex-col items-center justify-between mx-10 my-8 text-permaGreen4 md:flex-row" }
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 2,
  src: _imports_0,
  class: "w-6 h-6",
  alt: "arrow"
}
const _hoisted_6 = { class: "font-space-grotesk-regular text-14px text-permaWhite2 text-center mt-4" }
const _hoisted_7 = { class: "text-white font-space-gtotesk-medium inline" }

import { ref, onMounted, computed } from 'vue'
import { useStore } from './store'
import Navbar from './components/Navbar/index.vue'
// import Footer from './components/Footer.vue'
import ConnectModal from '@/components/ConnectModal/index.vue'
import { initAndHandleEvents } from './libs/everpay'
import { ChainType } from './libs/everpay-js'
import { useI18n } from 'vue-i18n'
import NoticeModal from './components/NoticeModal.vue'
import { checkParentsHas } from '@/libs/util'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const { t } = useI18n()
const scrollTop = ref(0)
const windowWidth = ref(document.documentElement.offsetWidth)
const account = store.state.account ?? ''
const accChainType = store.state.accChainType
const isWelcomeModalTarget = checkParentsHas('welcomeModal')
const welcomeModalVisible = ref(false)
store.dispatch('updateEverpayInfoAsync')
onMounted(async () => {
  if (account && accChainType) {
    initAndHandleEvents({
      accChainType: accChainType as ChainType,
      store,
      t
    })
  }
  window.addEventListener('scroll', () => {
    scrollTop.value = document.documentElement.scrollTop
  })
  window.addEventListener('resize', () => {
    windowWidth.value = document.documentElement.offsetWidth
  })
  document.addEventListener('click', (e) => {
    if (!isWelcomeModalTarget(e.target as any)) {
      welcomeModalVisible.value = false
    }
  })
  window.addEventListener('load', () => {
    welcomeModalVisible.value = false
  })
})
const welcomPagelist = computed(() => {
  return [
    {
      name: t('exchange'),
      icon: false,
      href: '/',
      open: false
    },
    {
      name: t('run_node'),
      icon: false,
      href: '/pool',
      open: false
    },
    {
      name: t('tutorial'),
      icon: true,
      href: 'https://www.notion.so/permadao/PermaSwap-WIKI-EN-485cd6623f954902b61775e4f1a86717',
      open: true
    }
  ]
})
const shutdownVisible = ref(false)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Navbar, {
      "window-width": windowWidth.value,
      "scroll-top": scrollTop.value
    }, null, 8, ["window-width", "scroll-top"]),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_KeepAlive, null, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ], 1024))
      ]),
      _: 1
    }),
    _createVNode(ConnectModal),
    false
      ? (_openBlock(), _createBlock(NoticeModal, {
          key: 0,
          visible: welcomeModalVisible.value,
          title: "Welcome To Permaswap",
          class: "welcomeModal",
          confirm: _unref(t)('launch'),
          onClose: _cache[1] || (_cache[1] = ($event: any) => (welcomeModalVisible.value = false))
        }, {
          msg: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('welcome_to_page_title')), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(welcomPagelist), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass([(index !== 0) ? 'mt-4 md:mt-0' : '', "border-b border-permaGreen4 hover:text-permaGreen11 active:text-permaGreen9 flex items-center"]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (welcomeModalVisible.value = false))
                }, [
                  (!item.open)
                    ? (_openBlock(), _createBlock(_component_RouterLink, {
                        key: 0,
                        class: "",
                        to: item.href
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: item.href,
                        target: "_blank"
                      }, _toDisplayString(item.name), 9, _hoisted_4)),
                  (item.icon)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["visible", "confirm"]))
      : _createCommentVNode("", true),
    _createVNode(NoticeModal, {
      visible: shutdownVisible.value,
      title: "Announcement",
      confirm: _unref(t)('shutdown_enter'),
      onClose: _cache[2] || (_cache[2] = ($event: any) => (shutdownVisible.value = false))
    }, {
      msg: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode(_toDisplayString(_unref(t)('shutdown_content1')) + " ", 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('shutdown_time')), 1),
          _createTextVNode(" " + _toDisplayString(_unref(t)('shutdown_content2')), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible", "confirm"])
  ]))
}
}

})